
export const userValidationSchema = (isEditing = false,isCurrentUserAdminSupport = false) => {
  const rules = {
    firstName: {
      required: { value: true, message: "First name is required." },
      pattern: {
        value: /^[A-Za-z]+$/,
        message: "Only letters allowed.",
      },
    },
    lastName: {
      required: { value: true, message: "Last name is required." },
      pattern: {
        value: /^[A-Za-z]+$/,
        message: "Only letters allowed.",
      },
    },
    email: {
      required: { value: true, message: "Email is required." },
      pattern: {
        value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
        message: "Enter a valid email address.",
      },
    },
    userName: {
      required: { value: true, message: "Employee number is required." },
    },
    role: {
      required: { value: !isCurrentUserAdminSupport, message: "Role is required." },
    },
    ...(!isEditing && {
       password: {
        required: { value: true, message: "Password is required." },
        minLength: { value: 8, message: "Password must be at least 8 characters." },
        pattern: {
          value: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[\W_]).+$/,
          message:
            "Min 8: Aa, 0-9, !@#$",
        },
      },
    }),
  };


  const evaluateRule = (fieldRules, value) => {
    if (!fieldRules) return null;

    if (fieldRules.required?.value && !value?.toString().trim()) {
      return fieldRules.required.message;
    }
    if (fieldRules.pattern?.value && !fieldRules.pattern.value.test(value)) {
      return fieldRules.pattern.message;
    }
    if (fieldRules.minLength?.value && value?.length < fieldRules.minLength.value) {
      return fieldRules.minLength.message;
    }

    return null;
  };

  return {

    validateField(fieldName, value) {
      return evaluateRule(rules[fieldName], value);
    },

  
    validateAll(formData) {
      const errors = {};

      Object.entries(rules).forEach(([fieldName, fieldRules]) => {
        const error = evaluateRule(fieldRules, formData[fieldName]);
        if (error) errors[fieldName] = error;
      });

      return {
        isValid: Object.keys(errors).length === 0,
        errors,
      };
    },
  };
};